import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Clock, LogOut } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_visa-community/artifacts/vrwzubc4_Argo-Atlantic-logo.png';

const PendingApprovalPage = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4" data-testid="pending-approval-page">
      <div className="absolute inset-0 gradient-dark-glow opacity-50" />
      
      <Card className="w-full max-w-md relative glass-card animate-slide-up text-center">
        <CardHeader className="space-y-4">
          <Link to="/" className="flex justify-center">
            <img src={LOGO_URL} alt="Argo Atlantic" className="h-16 w-16" />
          </Link>
          <div className="mx-auto w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
            <Clock className="h-8 w-8 text-primary" />
          </div>
          <CardTitle className="font-serif text-2xl">Pending Approval</CardTitle>
          <CardDescription>
            Welcome, {user?.name}! Your account is currently pending approval from an administrator.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-muted/50 rounded-lg p-4 text-left">
            <p className="text-sm text-muted-foreground">
              To ensure a safe and trusted community, all new accounts require approval before accessing the platform. 
              You will receive notification once your account has been approved.
            </p>
          </div>
          
          <div className="text-sm text-muted-foreground">
            <p>Role requested: <span className="text-foreground capitalize">{user?.role}</span></p>
            <p>Email: <span className="text-foreground">{user?.email}</span></p>
          </div>

          <Button 
            variant="outline" 
            className="w-full" 
            onClick={logout}
            data-testid="logout-btn"
          >
            <LogOut className="mr-2 h-4 w-4" />
            Sign Out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default PendingApprovalPage;
